import axios from 'axios';
import Framework from '@greenville/framework';
import utils from '../../../common/utils';
import env from '../../../common/env';

export default async function getAgenticTools() {
  const token = utils.getToken();
  try {
    const response = await axios.get(`${env.EVERGREEN_API_BASE_URL}/agentictools`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    });
    const { data } = response;
    if (data.success) {
      const sortedTools = Array.isArray(data.tools)
        ? [...data.tools].sort((a, b) => {
            const aCustom = !!(a && a.custom);
            const bCustom = !!(b && b.custom);
            if (aCustom !== bCustom) return aCustom ? -1 : 1; // custom: true first
            const aLabel = (a && a.label ? String(a.label) : '').toLowerCase();
            const bLabel = (b && b.label ? String(b.label) : '').toLowerCase();
            return aLabel.localeCompare(bLabel);
          })
        : [];

      return { ...data, tools: sortedTools };
    }
    const notification = {
      open: true,
      type: 'error',
      message: `Error fetching tools`
    };
    Framework.getStoreRegistry().getStore('notificationState').set(notification);
    return null;
  } catch (err) {
    return err;
  }
}
